import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ApplicationsPage from '@/pages/applications/page';
import ScoringPage from '@/pages/scoring/page';
import ExpertsPage from '@/pages/experts/page';
import LeadsPage from '@/pages/leads/page';
import MatchingPage from '@/pages/matching/page';
import RevenuePage from '@/pages/revenue/page';
import PerformancePage from '@/pages/performance/page';
import MessagesPage from '@/pages/messages/page';
import LeaderboardPage from '@/pages/leaderboard/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/applications', element: <ApplicationsPage /> },
  { path: '/scoring', element: <ScoringPage /> },
  { path: '/experts', element: <ExpertsPage /> },
  { path: '/leads', element: <LeadsPage /> },
  { path: '/matching', element: <MatchingPage /> },
  { path: '/revenue', element: <RevenuePage /> },
  { path: '/performance', element: <PerformancePage /> },
  { path: '/messages', element: <MessagesPage /> },
  { path: '/leaderboard', element: <LeaderboardPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
